import { useEffect, useState } from "react";
import DropDown from "../../formComponents/DropDown";
import { dbDataStore, externalStore } from "../../store/Store";

export default function JobsDropdown({ setNewJob, newJob }) {
  // global
  const propConnectJobs = externalStore((data) => data.propConnectJobs);
  const projectData = dbDataStore((dbData) => dbData.projectData);

  const [jobsDD, setJobsDD] = useState([]);
  useEffect(() => {
    let results = [];
    if (propConnectJobs && propConnectJobs.data) {
      propConnectJobs.data.forEach((job) => {
        let exists = []
        if (projectData) {
          exists = projectData.filter((x) => x.pc_job_id === job.id);
        }
        if (
          (job.working_status === "Active" ||
            job.working_status === "Not Started") &&
          exists.length === 0
        ) {
          results.push({ value: job.id, label: job.name });
        }
      });
    }
    setJobsDD(results);
  }, [propConnectJobs, projectData]);

  const handleJob = (option, e) => {
    setNewJob({
      ...newJob,
      job_name: option.label,
      pc_job_id: option.value,
    });
  };

  return (
    <DropDown
      name={"pc_job_id"}
      title={"Job Name"}
      options={jobsDD}
      onChange={handleJob}
      className={"dropdown"}
      maxMenuHeight={200}
      placeholder={"Select Job"}
    />
  );
}
